export const typeView = {
  empty: 1,
  metaDataValues: 2,
  entityValues: 3
}
